export enum UnavailableType {
  CHECKIN = 'CHECKIN', // 체크인 리뷰 작성 불가능
  REVIEW = 'REVIEW', // 체크인 외 리뷰 작성 불가능 (타임라인, 예약, 주문 리뷰쓰기 등)
  /**
   * 마플 접속 시 팝업 노출 여부를 바로 체크하는 케이스
   * 1. 징계기간이 지났지만 고지가 되지 않은 케이스 (isPenaltyEndWithoutNotice)
   * 2. 앱에서 경고/정지 유저로 리다이렉트된 케이스
   */
  ENTRY_CHECK = 'ENTRY_CHECK',
}
